import React from 'react';
import { TpPromptTaskContext, TpTaskFormData, TpTaskFormElemDef, TpTaskFormParsedElemData } from './interfaces';
import { ElemValueWrapper } from '../helpers/ElemValueWrapper';

function setInitialData(elemDef: any, ctx: TpPromptTaskContext, formData: TpTaskFormData) {
  formData.elemValues[elemDef.id] = elemDef.defaultValue;
}

function generate(
  elemDef: any,
  ctx: TpPromptTaskContext,
  formData: TpTaskFormData,
  updateElemValue: (elemId: string, newValue: any) => void,
) {
  return (
    <ElemValueWrapper elemName={elemDef.displayName}>
      <input
        type="checkbox"
        style={{ width: '20px', height: '20px' }}
        id={elemDef.id}
        value={formData.elemValues[elemDef.id] || false}
        checked={formData.elemValues[elemDef.id] || false}
        onChange={(ev) => {
          updateElemValue(elemDef.id, ev.target.checked);
        }}
      />
    </ElemValueWrapper>
  );
}

function parseElemValue(ctx: TpPromptTaskContext, elemDef: any, input: any): TpTaskFormParsedElemData {
  return {
    value: input || false,
    errorString: null,
  };
}

const taskFormElemBooleanDef: TpTaskFormElemDef = {
  type: 'boolean',
  name: 'Boolean',
  description: 'Enable or disable a specific flag.',
  hasData: true,
  setInitialData,
  generate,
  parseElemValue,
};

export default taskFormElemBooleanDef;
